<div class="embed-responsive">
    <div id="imageContainer" class="embed-responsive-item">
        <div id="zoomedImageArea" [hidden]="isLoading">
            <div class="image-wrapper">
                <img
                    [src]="attachment.url || attachment.previewUrl"
                    class="image-preview"
                    (click)="preventModalClose($event)"
                    [alt]="'Zoomed image' | translate" />
            </div>
        </div>

        @if (isLoading) {
            <sb-loader></sb-loader>
        }
    </div>
</div>

<div class="d-flex buttons-row" (click)="preventModalClose($event)">
    <button
        class="btn btn-icon btn-transparent"
        (click)="zoomOut()"
        [attr.aria-label]="'Zoom out' | translate"
        [disabled]="isMinZoomReached || !wzoom"
        tooltip="{{ 'Zoom out' | translate }}"
        container="body">
        <sb-inline-svg class="icon icon-sm" [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Zoom-out icon.svg'">
        </sb-inline-svg>
    </button>
    <button
        class="btn btn-icon btn-transparent ms-2"
        (click)="zoomIn()"
        [attr.aria-label]="'Zoom in' | translate"
        [disabled]="isMaxZoomReached || !wzoom"
        tooltip="{{ 'Zoom in' | translate }}"
        container="body">
        <sb-inline-svg class="icon icon-sm" [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Zoom-in icon.svg'">
        </sb-inline-svg>
    </button>
    <button
        class="btn btn-icon btn-transparent ms-2"
        (click)="resetZoom()"
        [disabled]="isMinZoomReached || !wzoom"
        [attr.aria-label]="'Reset zoom' | translate"
        tooltip="{{ 'Reset zoom' | translate }}"
        container="body">
        <sb-inline-svg class="icon icon-sm" [url]="'./sb-tools/theme/images/Svg icons WEB/Web icons/Minimize icon.svg'">
        </sb-inline-svg>
    </button>
</div>
